module.exports = __webpack_public_path__ + "static/media/chevron-up-green.2e41529a.svg";